import { notification } from 'antd';
import 'react-notifications/lib/notifications.css';

export const notif = (type, title, message) => {
    notification[type]({
        message: title,
        description : message,
    });
};
